
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function AccessPage() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    // Schema.org JSON-LD for Place
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Place",
      "name": "南森町鍼灸院",
      "description": "南森町駅徒歩5分、大阪天満宮駅徒歩2分の便利な立地にある鍼灸院です。",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/access`,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "東天満2丁目2-3 ダイアパレス南森町704",
        "addressLocality": "大阪市北区",
        "postalCode": "530-0044",
        "addressCountry": "JP"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "34.6937",
        "longitude": "135.5123"
      },
      "telephone": "06-6949-8663",
      "openingHours": [
        "Mo-Sa 10:00-13:00",
        "Mo-Fr 14:30-20:00",
        "Sa 14:00-18:00"
      ]
    });
    document.head.appendChild(script);

    // Set page title and meta description
    document.title = "アクセス - 南森町鍼灸院";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '南森町鍼灸院へのアクセス方法。南森町駅徒歩5分、大阪天満宮駅徒歩2分。詳しい道順と診療時間をご案内します。');
    }

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* ヘッダー */}
      <header className="shadow-sm border-b border-gray-100" style={{ backgroundColor: '#D8F25E' }}>
        <div className="max-w-6xl mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center cursor-pointer">
              <div className="text-center">
                <h1 className="text-2xl md:text-4xl font-bold" style={{ fontFamily: '"Hiragino Sans", "Noto Sans JP", sans-serif', color: '#526D1A' }}>
                  南森町鍼灸院
                </h1>
                <p className="mt-1 md:mt-2 text-sm md:text-lg opacity-90" style={{ color: '#526D1A' }}>女性・小児専門（乳幼児〜小・中学生）</p>
              </div>
              <div className="ml-2 md:ml-0 -mt-2 md:-mt-4">
                <img
                  src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/e2fcab9355782d68579ae8474689f655.webp"
                  alt="ハリネズミのマスコット"
                  className="w-16 h-16 md:w-28 md:h-28 object-contain"
                />
              </div>
            </Link>
            
            {/* デスクトップナビゲーション */}
            <nav className="hidden md:flex space-x-6 lg:space-x-8">
              <Link to="/" className="text-base lg:text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap" style={{ color: '#526D1A' }}>
                ホーム
              </Link>
              <Link to="/about" className="text-base lg:text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap" style={{ color: '#526D1A' }}>
                当院について
              </Link>
              <Link to="/menu" className="text-base lg:text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap" style={{ color: '#526D1A' }}>
                治療料金
              </Link>
              <Link to="/access" className="text-base lg:text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer border-b-2 whitespace-nowrap" style={{ color: '#526D1A', borderColor: '#526D1A' }}>
                アクセス
              </Link>
              <Link to="/contact" className="text-base lg:text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap" style={{ color: '#526D1A' }}>
                ご予約・お問い合わせ
              </Link>
            </nav>

            {/* モバイルメニューボタン */}
            <button
              className="md:hidden p-2 rounded-md cursor-pointer"
              style={{ color: '#526D1A' }}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {/* モバイルナビゲーション */}
          {isMobileMenuOpen && (
            <nav className="md:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
              <div className="flex flex-col space-y-3">
                <Link 
                  to="/" 
                  className="text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer py-2" 
                  style={{ color: '#526D1A' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  ホーム
                </Link>
                <Link 
                  to="/about" 
                  className="text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer py-2" 
                  style={{ color: '#526D1A' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  当院について
                </Link>
                <Link 
                  to="/menu" 
                  className="text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer py-2" 
                  style={{ color: '#526D1A' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  治療料金
                </Link>
                <Link 
                  to="/access" 
                  className="text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer py-2 border-b-2" 
                  style={{ color: '#526D1A', borderColor: '#526D1A' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  アクセス
                </Link>
                <Link 
                  to="/contact" 
                  className="text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer py-2" 
                  style={{ color: '#526D1A' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  ご予約・お問い合わせ
                </Link>
              </div>
            </nav>
          )}
        </div>
      </header>

      <div className="max-w-6xl mx-auto px-4 py-12">
        {/* ページタイトル */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4" style={{ color: '#526D1A' }}>アクセス</h1>
          <p className="text-lg text-gray-600">南森町鍼灸院へのアクセス方法</p>
        </div>

        {/* アクセス情報 */}
        <section className="mb-16">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* 基本情報 */}
            <div className="bg-white rounded-lg shadow-md p-8">
              <h2 className="text-2xl font-bold mb-6" style={{ color: '#526D1A' }}>基本情報</h2>
              <div className="space-y-4">
                <div className="flex items-start">
                  <i className="ri-map-pin-line text-xl mr-3 mt-1" style={{ color: '#D8F25E' }}></i>
                  <div>
                    <h3 className="font-semibold text-gray-800">住所</h3>
                    <p className="text-gray-600">〒530-0044<br />
    大阪市北区東天満2丁目2-3<br />
    ダイアパレス南森町704</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <i className="ri-phone-line text-xl mr-3 mt-1" style={{ color: '#D8F25E' }}></i>
                  <div>
                    <h3 className="font-semibold text-gray-800">電話番号</h3>
                    <p className="text-gray-600">06-6949-8663<br />
    ＊治療中は電話に出れない場合がございます。<br />
    折り返しお電話しますので、お名前と電話番号をお願いします。</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div>
                    <h3 className="font-semibold text-gray-800"></h3>
                  </div>
                </div>
              </div>
            </div>

            {/* 診療時間の表 */}
            <div className="bg-white rounded-lg shadow-md p-8">
              <h2 className="text-2xl font-bold mb-6" style={{ color: '#526D1A' }}>診療時間</h2>
              <div>
                <table className="w-full border-collapse">
                  <thead>
                    <tr style={{ backgroundColor: '#D8F25E' }}>
                      <th className="border border-gray-300 px-2 md:px-4 py-3 text-center font-bold text-xs md:text-base" style={{ color: '#526D1A' }}>時間</th>
                      <th className="border border-gray-300 px-1 md:px-2 py-3 text-center font-bold text-xs md:text-base" style={{ color: '#526D1A' }}>月</th>
                      <th className="border border-gray-300 px-1 md:px-2 py-3 text-center font-bold text-xs md:text-base" style={{ color: '#526D1A' }}>火</th>
                      <th className="border border-gray-300 px-1 md:px-2 py-3 text-center font-bold text-xs md:text-base" style={{ color: '#526D1A' }}>水</th>
                      <th className="border border-gray-300 px-1 md:px-2 py-3 text-center font-bold text-xs md:text-base" style={{ color: '#526D1A' }}>木</th>
                      <th className="border border-gray-300 px-1 md:px-2 py-3 text-center font-bold text-xs md:text-base" style={{ color: '#526D1A' }}>金</th>
                      <th className="border border-gray-300 px-1 md:px-2 py-3 text-center font-bold text-xs md:text-base" style={{ color: '#526D1A' }}>土</th>
                      <th className="border border-gray-300 px-1 md:px-2 py-3 text-center font-bold text-xs md:text-base" style={{ color: '#526D1A' }}>日</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border border-gray-300 px-2 md:px-4 py-3 text-center font-medium bg-gray-50 text-xs md:text-base">午前<br />10:00-13:00</td>
                      <td className="border border-gray-300 px-1 md:px-2 py-3 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                      <td className="border border-gray-300 px-1 md:px-2 py-3 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                      <td className="border border-gray-300 px-1 md:px-2 py-3 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                      <td className="border border-gray-300 px-1 md:px-2 py-3 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                      <td className="border border-gray-300 px-1 md:px-2 py-3 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                      <td className="border border-gray-300 px-1 md:px-2 py-3 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                      <td className="border border-gray-300 px-1 md:px-2 py-3 text-center text-sm md:text-lg font-bold text-red-600">休</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-2 md:px-4 py-3 text-center font-medium bg-gray-50 text-xs md:text-base">午後<br />14:30-20:00<br /><span className="text-xs text-gray-600">土曜 14:00-18:00</span></td>
                      <td className="border border-gray-300 px-1 md:px-2 py-3 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                      <td className="border border-gray-300 px-1 md:px-2 py-3 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                      <td className="border border-gray-300 px-1 md:px-2 py-3 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                      <td className="border border-gray-300 px-1 md:px-2 py-3 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                      <td className="border border-gray-300 px-1 md:px-2 py-3 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                      <td className="border border-gray-300 px-1 md:px-2 py-3 text-center text-sm md:text-lg font-bold" style={{ color: '#526D1A' }}>◯</td>
                      <td className="border border-gray-300 px-1 md:px-2 py-3 text-center text-sm md:text-lg font-bold text-red-600">休</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="mt-4 text-sm text-gray-600 space-y-1">
                <p>※ 最終受付：平日18:30、土曜16:30</p>
                <p>※ 日・祝は休鍼（研修による臨時休鍼あり）</p>
              </div>
            </div>
          </div>
        </section>

        {/* 交通案内 */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-12" style={{ color: '#526D1A' }}>交通案内</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white rounded-lg shadow-md p-6 text-center border-t-4" style={{ borderTopColor: '#526D1A' }}>
              <i className="ri-train-line text-4xl mb-4" style={{ color: '#D8F25E' }}></i>
              <h3 className="text-lg font-semibold mb-3" style={{ color: '#526D1A' }}>谷町線・堤筋線</h3>
              <p className="text-gray-700">南森町駅３番出口から</p>
              <p className="text-xl font-bold" style={{ color: '#526D1A' }}>徒歩5分</p>
            </div>
            
            <div className="bg-white rounded-lg shadow-md p-6 text-center border-t-4" style={{ borderTopColor: '#D8F25E' }}>
              <i className="ri-train-line text-4xl mb-4" style={{ color: '#526D1A' }}></i>
              <h3 className="text-lg font-semibold mb-3" style={{ color: '#526D1A' }}>JR東西線</h3>
              <p className="text-gray-700">大阪天満宮駅9番出口から</p>
              <p className="text-xl font-bold" style={{ color: '#526D1A' }}>徒歩2分</p>
            </div>
            
            <div className="bg-white rounded-lg shadow-md p-6 text-center border-t-4" style={{ borderTopColor: '#526D1A' }}>
              <i className="ri-train-line text-4xl mb-4" style={{ color: '#D8F25E' }}></i>
              <h3 className="text-lg font-semibold mb-3" style={{ color: '#526D1A' }}>京阪本線</h3>
              <p className="text-gray-700">天満橋駅から</p>
              <p className="text-xl font-bold" style={{ color: '#526D1A' }}>徒歩10分</p>
            </div>
          </div>
        </section>

        {/* Googleマップとイラストマップを横並びに */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-12" style={{ color: '#526D1A' }}>マップ</h2>
          <div className="grid md:grid-cols-2 gap-8">
            {/* Googleマップ */}
            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="w-full h-80 bg-gray-100 rounded-lg">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3280.0123456789!2d135.5123456!3d34.6937!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e68d95e3a4c1%3A0x1234567890abcdef!2z44CSNTMwLTAwNDQg5aSn6Ziq5bqc5aSn6Ziq5biC5YyX5Yy65p2x5aSp5rqA77yS5LiB55uu77yS4oiS77yT!5e0!3m2!1sja!2sjp!4v1234567890123"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="rounded-lg"
                ></iframe>
              </div>
            </div>

            {/* イラストマップ */}
            <div className="bg-white rounded-lg shadow-md p-6">
              <img 
                src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/bb701e9b3bd258249eaf5e0d7533e251.webp" 
                alt="南森町周辺イラストマップ" 
                className="w-full h-80 object-cover rounded-lg"
              />
            </div>
          </div>
          
          {/* 駐車場・駐輪場情報 */}
          <div className="mt-8 bg-yellow-50 rounded-lg p-6 border-l-4" style={{ borderLeftColor: '#D8F25E' }}>
            <div className="flex items-start">
              <i className="ri-information-line text-2xl mr-3 mt-1" style={{ color: '#526D1A' }}></i>
              <div>
                <h3 className="text-lg font-semibold mb-3" style={{ color: '#526D1A' }}>駐車場・駐輪場について</h3>
                <div className="space-y-2">
                  <p className="text-gray-700">・付近に駐輪場はございません。</p>
                  <p className="text-gray-700">・周辺にコインパーキングはございます。</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 写真でルート案内 */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-12" style={{ color: '#526D1A' }}>写真でルート案内</h2>
          <div className="space-y-8">
            {/* JR大阪天満宮駅からのルート */}
            <div className="bg-white rounded-lg shadow-md p-8">
              <h3 className="text-2xl font-bold mb-6" style={{ color: '#526D1A' }}>JR大阪天満宮駅からのルート（最寄り駅・徒歩2分）</h3>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold mr-4 mt-1" style={{ backgroundColor: '#526D1A' }}>
                      1
                    </div>
                    <div>
                      <h4 className="font-semibold mb-2">JR大阪天満宮駅9番出口を出る</h4>
                      <img 
                        src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/17e47517e9bf4761b1c952111441a78c.webp" 
                        alt="JR大阪天満宮駅9番出口" 
                        className="w-full h-32 object-cover rounded-lg"
                      />
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold mr-4 mt-1" style={{ backgroundColor: '#526D1A' }}>
                      2
                    </div>
                    <div>
                      <h4 className="font-semibold mb-2">東天満方面へ直進</h4>
                      <img 
                        src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/be3332e5bfdd9ad7651f5a7832f16a9e.webp" 
                        alt="東天満方面への道" 
                        className="w-full h-32 object-cover rounded-lg"
                      />
                    </div>
                  </div>
                </div>
                
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold mr-4 mt-1" style={{ backgroundColor: '#526D1A' }}>
                      3
                    </div>
                    <div>
                      <h4 className="font-semibold mb-2">さらに直進</h4>
                      <img 
                        src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/4f762163e7d0f2e04aa4c31cca0fc438.webp" 
                        alt="ダイアパレス南森町" 
                        className="w-full h-32 object-cover rounded-lg"
                      />
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold mr-4 mt-1" style={{ backgroundColor: '#526D1A' }}>
                      4
                    </div>
                    <div>
                      <h4 className="font-semibold mb-2">ダイアパレス南森町に到着</h4>
                      <img 
                        src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/e8d8015cfba195317f09399a86f865ea.webp"
                        alt="建物内部"
                        className="w-full h-32 object-cover rounded-lg"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 地下鉄南森町駅からのルート */}
            <div className="bg-white rounded-lg shadow-md p-8">
              <h3 className="text-2xl font-bold mb-6" style={{ color: '#526D1A' }}>地下鉄南森町駅からの路線（徒歩5分）</h3>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold mr-4 mt-1" style={{ backgroundColor: '#D8F25E', color: '#526D1A' }}>
                      1
                    </div>
                    <div>
                      <h4 className="font-semibold mb-2">南森町駅3番出口を出る</h4>
                      <img 
                        src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/54fad897612ade057d3fce2eff07e508.webp" 
                        alt="南森町駅3番出口" 
                        className="w-full h-32 object-cover"
                      />
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold mr-4 mt-1" style={{ backgroundColor: '#D8F25E', color: '#526D1A' }}>
                      2
                    </div>
                    <div>
                      <h4 className="font-semibold mb-2">東天満方面へ歩く</h4>
                      <img 
                        src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/9dcf4db1dab4384640acd167b2f9df79.webp" 
                        alt="東天満方面への歩道" 
                        className="w-full h-32 object-cover"
                      />
                    </div>
                  </div>
                </div>
                
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold mr-4 mt-1" style={{ backgroundColor: '#D8F25E', color: '#526D1A' }}>
                      3
                    </div>
                    <div>
                      <h4 className="font-semibold mb-2">堀川小学校を左手に直進</h4>
                      <img 
                        src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/6bafa07fc6b72947b19f00f27f67e7be.webp" 
                        alt="目印の建物" 
                        className="w-full h-32 object-cover"
                      />
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold mr-4 mt-1" style={{ backgroundColor: '#D8F25E', color: '#526D1A' }}>
                      4
                    </div>
                    <div>
                      <h4 className="font-semibold mb-2">ダイアパレス南森町に到着</h4>
                      <img 
                        src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/e8d8015cfba195317f09399a86f865ea.webp" 
                        alt="南森町鍼灸院" 
                        className="w-full h-32 object-cover"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA セクション */}
        <section className="text-center">
          <div className="bg-white rounded-lg shadow-lg p-8 max-w-3xl mx-auto" style={{ backgroundColor: '#D8F25E' }}>
            <h2 className="text-3xl font-bold mb-6" style={{ color: '#526D1A' }}>ご予約・お問い合わせ</h2>
            <p className="text-lg text-gray-700 mb-8">
              まずはお気軽にご予約ください。<br />初めての方にも安心して受けていただけるよう、丁寧にお話しを伺います。
            </p>
            
            <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
              <button 
                className="bg-white text-white px-8 py-4 rounded-full text-xl font-bold shadow-xl hover:shadow-2xl transition-all duration-300 cursor-pointer whitespace-nowrap transform hover:scale-105"
                style={{ 
                  backgroundColor: '#526D1A',
                  border: '3px solid #526D1A'
                }}
                onClick={() => {
                  window.open('https://kenkounihari.seirin.jp/clinic/18451/reserve', '_blank');
                }}
              >
                <i className="ri-calendar-line mr-3"></i>
                今すぐ予約する
              </button>
              
              <Link 
                to="/contact"
                className="bg-white px-8 py-4 rounded-full text-xl font-bold shadow-xl hover:shadow-2xl transition-all duration-300 cursor-pointer whitespace-nowrap transform hover:scale-105 border-3"
                style={{ 
                  color: '#526D1A',
                  borderColor: '#526D1A'
                }}
              >
                <i className="ri-mail-line mr-3"></i>
                お問い合わせ
              </Link>
            </div>
          </div>
        </section>
      </div>

      {/* フッター */}
      <footer className="mt-16 py-8 text-center text-gray-600" style={{ backgroundColor: '#f8f9f0' }}>
        <div className="max-w-6xl mx-auto px-4">
          <p>&copy; 2025 南森町鍼灸院. All rights reserved.</p>
          <p className="mt-2">
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-gray-700 cursor-pointer"
            >
              Website Builder
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
}
